import { render, staticRenderFns } from "./StTeaserOverviewMediaDownloads.vue?vue&type=template&id=e0622eb2"
import script from "./StTeaserOverviewMediaDownloads.vue?vue&type=script&lang=ts"
export * from "./StTeaserOverviewMediaDownloads.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports